module.exports = __webpack_public_path__ + "static/img/nodata.0d28c3e.png";


//////////////////
// WEBPACK FOOTER
// ./static/image/hallNoSubmit/nodata.png
// module id = 34h1
// module chunks = 1